// 开发环境的商户id
const _dev_identityId = '46ic94jhpa6h';

export const identityId = !import.meta.env
  ? _dev_identityId
  : import.meta.env.DEV
  ? _dev_identityId
  : location.host.split('.')?.[0];

/**
 * env
 * @param mode
 * @param env
 */
export function getEnv(mode: string) {
  const config = {
    routerBase: '/', // 路由基本路径
    viteBase: '/', // 打包的基本路径
    apiUrl: '',
  };

  // 打包环境
  const BuildEnv = ['devTest', 'sit', 'uat'];

  if (mode === 'uat') {
    // uat环境
    config.apiUrl = `https://${identityId}.im-miner-api-im-poc.adhoc-uat.app`;
  } else if (mode === 'sit') {
    // sit环境
    config.apiUrl = `http://${identityId}.im-sit-dreaminglife.cn`;
  } else if (mode === 'devTest') {
    // 线上dev环境
    config.apiUrl = `http://${identityId}.im-dreaminglife.cn`;
  } else {
    // 本地开发
    config.apiUrl = ``;
    // config.apiUrl = `http://${identityId}.im-dreaminglife.cn`;
  }

  if (BuildEnv.includes(mode)) {
    // 打包环境
    if (['devTest', 'sit'].includes(mode)) {
      // 打包到子路径(根据模式名字 作为 子路径名字)
      config.routerBase = `/miner/`;
      config.viteBase = `/miner/`;
    } else {
      // uat
      // 打包到根路径
    }
  } else {
    // 本地开发环境
  }

  return config;
}

export const ENV = getEnv(import.meta.env?.MODE);
